<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
const props = defineProps<{ text: string; headingId: string }>();
const heading = ref<HTMLElement | null>(null);
const height = ref<number>();
let observer: ResizeObserver | undefined;
let observedCopy: HTMLElement | undefined;
let disposed = false;
function measure() {
  const copy = heading.value?.querySelector<HTMLElement>('.pun-copy:last-child');
  if (copy) {
    if (copy !== observedCopy && observer) {
      if (observedCopy) observer.unobserve(observedCopy);
      observedCopy = copy;
      observer.observe(copy);
    }
    height.value = Math.ceil(copy.getBoundingClientRect().height);
  }
}
watch(
  () => props.text,
  async () => {
    await nextTick();
    measure();
  },
);
onMounted(() => {
  observer = new ResizeObserver(measure);
  if (heading.value) observer.observe(heading.value);
  measure();
  void document.fonts.ready.then(() => {
    if (!disposed) measure();
  });
});
onBeforeUnmount(() => {
  disposed = true;
  observer?.disconnect();
});
</script>
<template>
  <h2
    :id="headingId"
    ref="heading"
    class="pun-headline"
    :style="height ? { height: `${height}px` } : undefined"
  >
    <Transition name="pun"
      ><span :key="text" class="pun-copy">“{{ text }}”</span></Transition
    >
  </h2>
</template>
